var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSolanaFmIcon15X22 = function SvgSolanaFmIcon15X22(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 22
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "solana-fm-icon-15x22_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 21286",
    d: "M0 0h14.981v21.743H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Logo Vector",
    clipPath: "url(#solana-fm-icon-15x22_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108579",
    d: "M0 10.808A10.884 10.884 0 0 1 10.872 0h.8v1.728h-.8a9.155 9.155 0 0 0-9.144 9.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108580",
    d: "M3.314 21.744v-1.728h.791a9.155 9.155 0 0 0 9.144-9.08h1.728A10.884 10.884 0 0 1 4.105 21.744Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108581",
    d: "M3.314 18.43v-1.728h.791a5.837 5.837 0 0 0 5.835-5.766h1.724a7.566 7.566 0 0 1-7.562 7.494Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108582",
    d: "M3.314 10.808a7.567 7.567 0 0 1 7.558-7.494h.8v1.728h-.8a5.837 5.837 0 0 0-5.83 5.766Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108583",
    d: "M3.314 15.116v-1.728h.791a2.518 2.518 0 0 0 2.52-2.452v-.064a4.248 4.248 0 0 1 4.247-4.244h.8v1.728h-.8a2.52 2.52 0 0 0-2.515 2.452v.064a4.25 4.25 0 0 1-4.252 4.245Z"
  }))));
};
export default SvgSolanaFmIcon15X22;